module.exports = __webpack_public_path__ + "static/media/Drifloon_gaussian2.b2d62b0b.png";